import useAuthentication from "@hooks/useAuthentication";

import PatientEncounterv1 from "./v1";
import PatientEncounterv2 from "./v2";

export default function PatientEncounter() {
  const { user } = useAuthentication();
  return (
    <>
          {user?.region === "UAE_REGION" ? (
            <PatientEncounterv1 />
          ) : (
            <PatientEncounterv2 />
          )}
    </>
  );
}
